/**
 * @license
 * Copyright Tyler Technologies, Inc. 
 * License: Apache-2.0
 */
import { COMPONENT_NAME_PREFIX } from '../constants';
import { supportsPopover } from '../core';
const elementName = `${COMPONENT_NAME_PREFIX}overlay`;
const observedAttributes = {
    ANCHOR: 'anchor',
    NO_ANCHOR: 'no-anchor',
    OPEN: 'open',
    INLINE: 'inline',
    PLACEMENT: 'placement',
    POSITION_STRATEGY: 'position-strategy',
    HIDE: 'hide',
    PERSISTENT: 'persistent',
    SHIFT: 'shift',
    FLIP: 'flip',
    BOUNDARY: 'boundary',
    FALLBACK_PLACEMENTS: 'fallback-placements'
};
const attributes = {
    ...observedAttributes,
    POSITION_PLACEMENT: 'position-placement',
    CLIPPED_X: 'clipped-x',
    CLIPPED_Y: 'clipped-y'
};
const classes = {
    OVERLAY: 'forge-overlay'
};
const selectors = {
    ROOT: `.${classes.OVERLAY}`
};
const events = {
    LIGHT_DISMISS: `${elementName}-light-dismiss`,
    DESCENDANT_TEST: `${elementName}-descendant-test`
};
const defaults = {
    HIDE: 'anchor-hidden',
    FLIP: 'auto',
    SHIFT: 'auto'
};
export const OVERLAY_CONSTANTS = {
    elementName,
    observedAttributes,
    attributes,
    classes,
    selectors,
    events,
    defaults
};
export const SUPPORTS_POPOVER = supportsPopover();
export const overlayStack = Symbol('overlayStack');
